import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
} from '@mui/material';
import BusinessForm from './businessForm';

interface AddBusinessModalProps {
    open: boolean;
    onClose: () => void;
}

const modalStyle = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: 800,
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'auto'
};

const AddBusinessModal = ({ open, onClose }: AddBusinessModalProps) => {
    const [isDisabled, setIsDisabled] = useState(false);

    const handleFormSubmitSuccess = () => {
        setTimeout(() => {
            onClose();
        }, 100);
    };

    if (!open) return null;

    return (
      <Modal open={open} onClose={onClose} keepMounted={false}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" gutterBottom>
            Add New Business profile
          </Typography>
          <BusinessForm 
            isDisabled={isDisabled}
            onSubmitSuccess={handleFormSubmitSuccess}
            isNewBusiness={true}
          />
        </Box>
      </Modal>
    );
};

export default AddBusinessModal; 